export class AppConstants {

    public static readonly CACHE_LIFESPAN_IN_HOURS = 12;

}
